import { BaseModel } from "@shared/models/base.model";
import {
  CompanyShareholderType,
  OfficerDocumentStatusEnum,
  ShareholdingDetailType,
  ShareTypeEnum
} from "@generated/graphql";
import { Company } from "@modules/company/models/company.model";
import { companyFactory } from "@modules/company/factories/company.factory";
import { officerFactory } from "@modules/officer/factories/officer.factory";
import { Officer } from "@modules/officer/models/officer.model";
import { startCase } from "lodash-es";
import { AppStatusType } from "@shared/component/common/status/status.component";
import { CompanyIndirectShareholder } from "@modules/company/models/company-indirect-shareholder.model";
// import {DateTime} from "luxon";
import { parseAnyDate } from "@shared/helpers/date-time.helpers";
import { OfficerRoleEnum } from "@shared/types/officerEnum";
export class CompanyShareholder extends BaseModel implements CompanyShareholderType {
  //TODO Should get this value from BE
  static readonly UBO = 0.25

  id: string;
  company: Company;
  canUploadDocument: boolean;
  canDeleteDocument: boolean;
  officer: Officer;
  canCreateShareholder: boolean
  isUBO: boolean
  isNominee: boolean;
  ownership: number;
  cessationDate: Date;
  effectiveDate: Date;
  companyId: string;
  documentsStatus: OfficerDocumentStatusEnum;
  shareholders: CompanyIndirectShareholder[];
  isRequiredKyc: boolean
  canViewShareholders: boolean
  remainingPercentageOfShares: number
  remainingPercentageOfSharesForUpdating: number
  percentageOfShares: number
  shareholdingDetails: ShareholdingDetailType[]
  layer: number
  allocatedCapitalTotal: number
  isWaitingForApprovalDeletion: boolean
  _model: string;
  __typename: 'CompanyShareholderType';

  constructor(state: CompanyShareholderType) {
    super(state);

    this.officer = officerFactory.tryCreating(state.officer)

    this.company = companyFactory.tryCreating(state.company)

    // Nested shareholders are hydrated from `shareholdersForOrganizationChart`.
    this.shareholders = []

    this.cessationDate = parseAnyDate(state.cessationDate);

    this.effectiveDate = parseAnyDate(state.effectiveDate);
  }

  get documentStatusLabel(): string {
    return startCase(this.documentsStatus.toLowerCase());
  }

  get documentsStatusStyle(): AppStatusType {
    switch (this.documentsStatus) {
      case OfficerDocumentStatusEnum.AwaitingReview: {
        return 'warn';
      }
      case OfficerDocumentStatusEnum.Verified: {
        return 'success';
      }
      case OfficerDocumentStatusEnum.Rejected: {
        return 'error';
      }
      default:
        return 'default';
    }
  }

  get title(): string {
    return 'Shareholder'
  }

  get name(): string {
    return this.isNominee ? 'Nominee' : this.officer?.name;
  }

  get icon(): string {
    switch (this.officer.officerProfile.__typename) {
      case "OfficerCompanyType":
        return 'apartment';
      case "OfficerPersonType":
        return this.isUBO ? 'person-UBO' : 'person'
      default:
        return '';
    }
  }

  get remainingOfShares(): number {
    return this.remainingPercentageOfShares
  }

  get renderOfficerRole(): string {
    return 'Shareholder'
  }

  get corporateShareholders(): CompanyIndirectShareholder[] {
    return this.shareholders.filter(item => item.officer.officerProfile.__typename === 'OfficerIndirectCompanyType')
  }

  get individualShareholders(): CompanyIndirectShareholder[] {
    return this.shareholders.filter(item => item.officer.officerProfile.__typename === 'OfficerIndirectPersonType')
  }

  get totalOrdinaryShares() {
    return this.shareholdingDetails
      .filter(i => i.shareType.name === ShareTypeEnum.Ordinary)
      .reduce((shares, item) => {
        return item.numberOfShares + shares
      }, 0)
  }

  get officerRole() {
    return OfficerRoleEnum.SHAREHOLDER
  }

  getModelName(): string {
    return CompanyShareholder.name;
  }

  layerShareholder(): number {
    return this.layer
  }

  isIndirect() {
    return false
  }

  isIndirectKYC() {
    return false;
  }
}
